import { create } from "zustand";
import { DEFAULT_FORM_DATA } from "../Components/AddVariation/AddVariation.constants";
import { getTableConfig } from "../utils/OfferingVariationsList.tableConfig";

export const useOfferingVariationListStore = create((set) => ({
  membershipListMap: [],
  variantPricesByMembership: [],
  variationMapByMembershipId: [],
  defaultMembershipId: null,
  isMembership: false,
  provider: {},
  offeringUuid: null,
  isEnabled: false,
  offeringDetails: false,
  processing: false,
  showAddVariation: false,
  showDeleteModal: false,
  isOpenKycModal: false,
  showKycColumn: false,
  selectedVariation: null,
  showInternationalPrice: false,
  formData: { ...DEFAULT_FORM_DATA },
  errorObject: {},
  columnConfig: [...getTableConfig()],
  setMembershipListMap: (val) => set({ membershipListMap: val }),
  setVariantPricesByMembership: (val) =>
    set({ variantPricesByMembership: val }),
  setVariationMapByMembershipId: (val) =>
    set({ variationMapByMembershipId: val }),
  setDefaultMembershipId: (val) => set({ defaultMembershipId: val }),
  setIsMembership: (val) => set({ isMembership: val }),
  setProvider: (val) => set({ provider: val }),
  setOfferingUuid: (val) => set({ offeringUuid: val }),
  setIsEnabled: (val) => set({ isEnabled: val }),
  setOfferingDetails: (val) => set({ offeringDetails: val }),
  setProcessing: (val) => set({ processing: val }),
  setShowAddVariation: (val) => set({ showAddVariation: val }),
  setShowDeleteModal: (val) => set({ showDeleteModal: val }),
  setIsOpenKycModal: (val) => set({ isOpenKycModal: val }),
  setShowKycColumn: (val) => set({ showKycColumn: val }),
  setSelectedVariation: (val) => set({ selectedVariation: val }),
  setShowInternationalPrice: (val) => set({ showInternationalPrice: val }),
  setFormData: (val) => set({ formData: val }),
  setErrorObject: (val) => set({ errorObject: val }),
  setColumnConfig: (val) => set({ columnConfig: val }),
}));
